<div class="modal-header has-close">
  <div class="modal-title">
    <span>{{ title }}</span>
  </div>
  <button
  *ngIf="showCloseCTA"
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img src="assets/icons/ic-close@3x.svg" alt="" />
  </button>
</div>
<div class="modal-body" [innerHTML]="content"></div>
<div class="modal-footer" *ngIf="buttonText">
  <app-primary-button (click)="onClickBtn()">{{
    buttonText
  }}</app-primary-button>
</div>
